import script from "./NotificationMoveAllConfirm.vue?vue&type=script&setup=true&lang=ts"
export * from "./NotificationMoveAllConfirm.vue?vue&type=script&setup=true&lang=ts"

import "./NotificationMoveAllConfirm.vue?vue&type=style&index=0&id=e63ceeee&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e63ceeee"]])

export default __exports__